<template>
    <Form style="line-height:32px" :label-width="120" inline>
        <div>提交后将由仓储人员审核，审核结果请于3-5个工作日进入单据查看，是否确认提交？</div>
        <FormItem label=" 是否推送物流">
            <RadioGroup v-model="pushToLogistic">
                <Radio label="1">是</Radio>
                <Radio label="2">否</Radio>
            </RadioGroup>
        </FormItem>
        <FormItem label='中转仓' v-if="show&&pushToLogistic==2">
            <Select  v-model="baseData.orgwarehouseId" filterable>
                <Option v-for="item in warehouses" :value="item.id" :key="item.id">{{ item.code }}({{item.title}})</Option>
            </Select>
        </FormItem>
        <footer class="text-right">
             <Button type="primary" @click="submit" class="margin-right-10">提交</Button>
             <Button @click="cancel">取消</Button>
        </footer>
        <Spin size="large" fix v-if="loading"></Spin>
    </Form>
</template>
<script>
import { HttpUpdateShipBillStatus, HttpShipBill, HttpSaveShipBillPlan } from '@/service/boss/shipment'
import { mapGetters } from 'vuex'
export default {
    props: ['status', 'id', 'shipType'],
    data() {
        return {
            pushToLogistic: "1",
            loading: false,
            baseData: { orgwarehouseId: "" },
            show: true
        }
    },
    created() {
        this.getDetail()
    },
    computed: {
        ...mapGetters('boss',['warehouses']),
    },
    methods: {
        cancel() {
            this.$emit('on-close')
        },
        //加载详情
        async getDetail() {
            if (this.shipType != 1) return this.show = false;
            this.loading = true;
            return HttpShipBill({
                id: this.id
            }).then(res => {
                this.baseData = res.data.shipmentPlans || {};
                this.show = !this.baseData.orgwarehouseId;
                this.loading = false;
            }, err => {
                this.loading = false;
                this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
            });
        },
        //头单据
        async submitHeadBill() {
            if (!this.baseData.orgwarehouseId) return this.$Message.warning('请指定中转仓');
            this.loading = true;
            return HttpSaveShipBillPlan(this.baseData).then((res) => {
                this.updateBillStatus();
            }, (err) => {
                this.loading = false;
                this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
            })
        },
        async updateBillStatus() {
            this.loading = true;
            HttpUpdateShipBillStatus({
                pushToLogistic: this.pushToLogistic,
                status: this.status,
                id: this.id,
            }).then(res => {
                this.cancel();
                this.$emit('on-update');
            }, err => {
                this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
            }).finally(() => {
                this.loading = false;
            })
        },
        async submit() {
            const pushToLogistic = this.pushToLogistic;
            if (pushToLogistic == 1) {
                this.updateBillStatus()
            } else {
                (this.show) ? this.submitHeadBill() : this.updateBillStatus();
            }
        }
    }
}
</script>

